<div class="content-wrapper">
    <div class="content-body">
        <div id="user-profile">
            <div class="row">
                <div class="col-12">
                    <button class="btn btn-icon btn-flat-primary mb-1" type="button" (click)="goBack()">
                        <i data-feather="arrow-left" class="mr-8px"></i>&nbsp;Back to Partners
                    </button>
                    <div class="card profile-header mb-2">
                        <div class="position-relative">
                            <div class="profile-img-container d-flex align-items-center">
                                <div class="profile-img">
                                    <img src="{{partner?.partner_logo?.url}}"
                                         class="rounded img-fluid"
                                         alt="{{partner?.name}}"/>
                                </div>
                                <div class="profile-title ml-3">
                                    <h2>{{partner?.name}}</h2>
                                    <p>{{partner?.website}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="profile-header-nav">
                            <nav class="navbar navbar-expand-md navbar-light justify-content-end justify-content-md-between w-100">
                                <button
                                        class="btn btn-icon navbar-toggler"
                                        type="button"
                                        data-target="#navbarSupportedContent"
                                        aria-controls="navbarSupportedContent"
                                        aria-expanded="false"
                                        aria-label="Toggle navigation"
                                        (click)="toggleMenu = !toggleMenu"
                                        rippleEffect
                                >
                                    <i data-feather="align-justify" class="font-medium-5"></i>
                                </button>
                                <div class="collapse navbar-collapse" id="navbarSupportedContent"
                                     [ngbCollapse]="toggleMenu">
                                    <div class="profile-tabs d-flex justify-content-between flex-wrap mt-1 mt-md-0">
                                        <ul class="nav nav-pills mb-0">
                                            <li class="nav-item">
                                                <a class="nav-link font-weight-bold" routerLink="universities" routerLinkActive="active">
                                                    <span class="d-none d-md-block">Universities</span>
                                                    <i data-feather="home" class="d-block d-md-none"></i>
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link font-weight-bold" routerLink="courses" routerLinkActive="active">
                                                    <span class="d-none d-md-block">Courses</span>
                                                    <i data-feather="book-open" class="d-block d-md-none"></i>
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link font-weight-bold" routerLink="leads" routerLinkActive="active">
                                                    <span class="d-none d-md-block">Leads</span>
                                                    <i data-feather="users" class="d-block d-md-none"></i>
                                                </a>
                                            </li>
                                            <li class="nav-item" *ngIf="partnerSlug === 'paiu'">
                                                <a class="nav-link font-weight-bold" routerLink="paiu-transaction" routerLinkActive="active">
                                                    <span class="d-none d-md-block">PAIU Transaction</span>
                                                    <i data-feather="credit-card" class="d-block d-md-none"></i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <router-outlet></router-outlet>
        </div>
    </div>
</div>
